import React, { useState } from "react";
import { Form, Input, InputNumber, Button, Row, Col, notification } from "antd";
import {
  TagOutlined,
  EnvironmentOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import { addPlaceApi } from "../../../../api/place";
import { getAccessToken } from "../../../../api/auth";

import "./AddPlaceForm.scss";

export default function AddPlaceForm(props) {
  const { setIsVisibleModal, setReloadPlaces } = props;

  const [inputs, setInputs] = useState({
    //place_code: "",
    description: "",
  });

  const [disabledSubmit, setDisabledSubmit] = useState(false);

  const isFormValid = (e) => {
    //console.log(inputs);
    let errorExists = false;
    if (!inputs.description) {
      notification["error"]({
        message: "Obligatorio: descripcion.",
      });
      errorExists = true;
    }
    return errorExists;
  };

  const addPlace = async (e) => {
    e.preventDefault();

    if (!isFormValid()) {
      if(!disabledSubmit){
        setDisabledSubmit(true);
        const accessToken = getAccessToken();

        await addPlaceApi(accessToken, inputs)
          .then((response) => {
            if (
              response.message === "ERR_CONNECTION_REFUSED" ||
              response.message === "Failed to fetch" ||
              response === undefined
            ) {
              notification["error"]({
                message: "Servidor caido",
              });
              setDisabledSubmit(false);
            } else if (!response.place) {
              notification["error"]({
                message: response.message,
              });
              setDisabledSubmit(false);
              setReloadPlaces(true);
            } else {
              notification["success"]({
                message: "Lugar creado",
              });
              setIsVisibleModal(false);
              setReloadPlaces(true);
            }
            //setReloadPlaces(true);
          })
          .catch((err) => {
            notification["error"]({
              message: err,
            });
          });
      }
    }
  };

  return (
    <div className="add-place-form">
      <AddForm inputs={inputs} setInputs={setInputs} addPlace={addPlace} />
    </div>
  );
}

function AddForm(props) {
  const { inputs, setInputs, addPlace } = props;

  return (
    <Form className="form-add" onSubmit={addPlace}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col span={12}>
          <label className="control-label">Código</label>
          <Form.Item>
            <InputNumber
              prefix={<TagOutlined />}
              placeholder="Automático"
              value={inputs.place_code}
              onChange={(e) => setInputs({ ...inputs, place_code: e })}
              style={{ width: "100%" }}
              disabled={true}
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <label className="control-label">
            <span className="control-required">*</span> Descripción
          </label>
          <Form.Item>
            <Input
              //   placeholder="descripcion"
              value={inputs.description}
              onChange={(e) =>
                setInputs({ ...inputs, description: e.target.value })
              }
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="btn-submit"
          onClick={addPlace}
        >
          Crear
        </Button>
      </Form.Item>
    </Form>
  );
}
